import draggable from 'vuedraggable'
import DatePicker from 'vue2-datepicker'
import {SemipolarSpinner} from 'epic-spinners'

export const mixin = {
  components: {
    draggable, DatePicker, SemipolarSpinner
  },
  data: function () {
    return {

      countries: this.$store.getters['environment/getCountries'],
      multiSelect: {
        leaveUsers: null,
        assignedUser: null,
        costCompanies: null,
        sponsorCompanies: null,
        checkIn: [],
        checkOut: [],
        breakStart: [],
        breakEnd: [],
        checkIn2: [],
        checkOut2: [],
        checkIn3: [],
        checkOut3: [],
        checkIn4: [],
        checkOut4: [],
        countryCode: [],
        punchDate: null,
        employeeIDCreate: null,
        leaveTypeCreate: null,
        leaveTypeUpdate: null,
      },
      dateSelect: {
        leaveDateFrom: null,
        leaveDateTo: null,
      },
      pastDateRangeTemplates: [
        {
          text: 'Today',
          start: new Date(),
          end: new Date()
        },
        {
          text: 'Yesterday',
          start: this.$moment().subtract(1, 'd'),
          end: this.$moment().subtract(1, 'd')
        },
        {
          text: 'Last 7 Days',
          start: this.$moment().subtract(7, 'd'),
          end: new Date()
        },
        {
          text: 'This Month',
          start: this.$moment().startOf('month'),
          end: new Date()
        },
        {
          text: 'Last 90 Days',
          start: this.$moment().subtract(3, 'months'),
          end: new Date()
        },

      ]
    }
  },
  created: function () {
    console.log('Mixin: Mixin Used')
    this.countries = this.$store.getters['environment/getCountriesList'];
    this.countriesArabic = this.$store.getters['environment/getCountriesListArabic'];
  },

  computed: {
    lang(){
      return this.$store.getters['environment/getLang']
    },
    rtl(){
      return this.$store.getters['environment/getRTL']
    },
    countryMain(){
      return this.$store.getters['environment/getCountryMain']
    },
  },
  watch: {
    // countryMain: function (val, oldVal) {
    //   // if(oldVal !== val){alert(val);}
    //   //
    //   // this.setCountryMain(val);
    // },
  },
  methods: {
    setLanguage(lang){
      let language = lang;
      let rtl = 0;
      if(language === 'ar'){rtl = 1;}
      this.$store.dispatch('environment/setLanguage', {language, rtl})
          .then(response => {
            // alert('Changed')
          })
          .catch(error => {
            this.$snotify.error("Language Function Issue");
          })
    },

    // setCountry(country){
    //   let countryMain = country;
    //   this.$store.dispatch('environment/setCountry', {country})
    //       .then(response => {
    //         // alert('Changed')
    //       })
    //       .catch(error => {
    //         this.$snotify.error("Language Function Issue");
    //       })
    // },

      onLogout() {
        this.$store.dispatch('auth/logout')
            .then(response => {
              // alert('Logged Out.')
            })
            .catch(error => {
              // this.$snotify.error("Logout Issue");
            })

      },

    iScreen(sizes)
    {
      let result = false;
      for (let s of sizes) {
        if(s === this.$mq){result = true;}
      }
      return result;
    },

    iShowCollapse(menu){
      for(let items of menu)
      {
        for(let item of items.children)
        {
          if(item.link === this.$route.path || item.link === this.$route.path+this.$route.hash){items.toggle = true;}
        }
      }
    },

    iFormatDate(date){
      return this.$moment(date).format('Do MMM YY')
    },

    iTimeLeft(dueDate, completionDate){
      let icon = 'check';
      let color = 'green';
      let text = 'Done';

      if(!completionDate || completionDate === null || completionDate === ''){
        let a = this.$moment(dueDate);
        let b = this.$moment();
        let difference = a.diff(b, 'hours');

        if(difference === 0) {
          icon = 'calendar';
          color = '#c27b00';
          text = 'Few Minutes';
        }
        if(difference > 0) {
          icon = 'hourglass-half';
          color = '#c2b700';
          text = difference + ' hours left';
        }
        if(difference === 1) {
          text = difference + ' hour left';
        }
        if(difference > 12) {
          icon = 'hourglass-start';
          color = '#5d9e01';
          text = difference + ' hours left';
        }
        if(difference > 24) {
          icon = 'hourglass-start';
          color = '#5d9e01';
          text = (difference/24).toFixed(0) + ' day left';
        }
        if(difference > 48) {
          icon = 'hourglass-start';
          color = '#5d9e01';
          text = (difference/24).toFixed(0) + ' days left';
        }
        if(difference < 0) {
          icon = 'hourglass-end';
          color = '#b44940';
          text = -difference + ' hours late';
        }
        if(difference < -12) {
          icon = 'exclamation-circle';
          color = '#ef340c';
          text = -difference + ' hours late';
        }
        if(difference < -24) {
          icon = 'exclamation-circle';
          color = '#ef340c';
          text = (-difference/24).toFixed(0) + ' day late';
        }
        if(difference === -24) {
          text = (-difference/24).toFixed(0) + ' day late';
        }
        if(difference < -47) {
          text = (-difference/24).toFixed(0) + ' days late';
        }
      }
      return {
        'icon': icon,
        'color': color,
        'text': text
      }
    },

    logoutUser(){
      alert('Header')
    },

    iUpdatedAgo(date){
      let past = this.$moment(date);
      let now = this.$moment();
      return past.from(now);
    },

    iGetInitials (name){
      let initials = name.match(/\b\w/g) || [];
      initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
      return initials.substring(0,3);
    },

    iValidateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    iCleanHtml(html){
      let temp = document.createElement("div");
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || "";
    },

  }
}


// WEBPACK FOOTER //
// ./src/mixins/mixins.js